import React from 'react'
import { connect } from 'react-redux'
import MenuButton from './MenuButton'
import Ink from 'react-ink'
import PropTypes from 'prop-types'

class Menu extends React.Component {
  constructor(props) {
    super(props)

    this.state = { currentPage: 0 };

    this.handleTouchTap = this.handleTouchTap.bind(this);
  }

  handleTouchTap() {
    this.setState(state => ({ 
      currentPage: state.currentPage === 0 ? 1 : 0 
    }));
  }

  render() {
    const {
      posId,
      objectgroups
    } = this.props;

    const {
      currentPage
    } = this.state;

    const fromItem = 6 * currentPage;
    const toItem = 6 * (currentPage + 1);

    return (
      <div id="om_menubarcontainer">
        <div id="om_menubar">
          {objectgroups.slice(fromItem, toItem).map(objectgroup =>
            <MenuButton
              id={objectgroup.ObjectGroupId}
              key={objectgroup.ObjectGroupId}
              text={objectgroup.Description}
              processed={!objectgroup.ObjectItems.find(o => o.ProductionPosIds && o.ProductionPosIds.split(';').includes(posId.toString()))} />)}
        </div>
        {objectgroups.length > 6 &&
          <button className="menubuttonnext" onClick={this.handleTouchTap}>
            <i className={currentPage === 1 ? 'caret left icon' : 'caret right icon'} /><Ink />
          </button>
        }
      </div>)
  }
}

Menu.propTypes = {
  objectgroups: PropTypes.arrayOf(PropTypes.shape({
    ObjectGroupId: PropTypes.number.isRequired
  })).isRequired
}

function mapStateToProps(state) {
  return {
    objectgroups: state.objectManagementState.objectgroups,
    posId: state.generalState.posId
  }
}

export default connect(mapStateToProps)(Menu)



// WEBPACK FOOTER //
// src/objectmanagement/components/Menu.jsx